<template>
	<div
		class="flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100"
	>

		<div class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative mb-5 max-w-lg" role="alert">
			<strong class="font-bold">Systemumstellung!</strong>
			<span class="block">Der alte URL-Verkürzungsdienst wurde abgelöst. Sollten Sie noch keinen neuen Zugang erhalten haben, wenden Sie sich bitte an den CMS-Support unter <a href="mailto:cms-support@stadt.nuernberg.de">cms-support@stadt.nuernberg.de</a>.</span>
		</div>

		<h1
			class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
		>
			Anmeldung
		</h1>
		<form
			class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg"
		>
			<div class="mb-4">
				<label
					class="block font-medium text-sm text-gray-700"
					for="username"
				>
					Benutzername
				</label>
				<input
					class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full"
					v-model="username"
					type="text"
				/>
			</div>
			<div class="mb-6">
				<label
					class="block font-medium text-sm text-gray-700"
					for="password"
				>
					Passwort
				</label>
				<input
					class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full"
					v-model="password"
					type="password"
				/>
			</div>
			<div class="flex items-center justify-end">
				<router-link
							to="/forgot-password" class="mr-auto">
							Passwort vergessen?
						</router-link>
				<form-button
					:type="button"
					:button="secondary"
					@click.prevent="login"
				>
					Anmelden
				</form-button>
			</div>
		</form>
	</div>
</template>

<script>
	import UserService from "@/services/user.js";
	import FormButton from "@/components/FormButton";

	export default {
		components: {
			FormButton,
		},
		data() {
			return {
				username: "",
				password: "",
			};
		},
		async created() {
			if (this.$store.getters.isLoggedIn) {
				this.$router.push("/url/overview");
			}
		},
		methods: {
			async login() {
				this.$emit("update-loading-overlay", true);
				try {
					this.$emit("update-loading-overlay", true);
					const credentials = {
						username: this.username,
						password: this.password,
					};

					const response = await UserService.login(credentials);
					if (response.success == 1) {
						const token = response.data.api_token;
						const user = response.data;

						this.$store.dispatch("login", { token, user });
						this.$emit("show-toast", {
							message: "Anmeldung erfolgreich!",
							type: "success",
						});

						if (parseInt(user.initial_password_set) == 1) {
							this.$router.push("/url/overview");
						} else {
							this.$emit("update-loading-overlay", false);
							this.$router.push("/initial-password")
						}
					} else {
						this.$emit("show-toast", {
							message: response.message,
							type: "error",
						});
						this.$emit("update-loading-overlay", false);
					}
				} catch (error) {
					console.log(error);
					this.$emit("update-loading-overlay", false);
				}
			},
		},
	};
</script>
